module.exports = __webpack_public_path__ + "img/ondoll_04.43f0d30c.png";